import { serializable, alias, list, object, primitive } from 'serializr';

export class LocationC02 {
  @serializable(alias('name', primitive()))
  locationName?: string;

  @serializable(alias('entity_type', primitive()))
  entityType?: string;

  // Rounding totalCO2 to 2 decimal places during deserialization
  @serializable(alias('total_co2e', primitive()))
  get totalCO2(): number | undefined {
    return this._totalCO2 !== undefined
      ? Number(this._totalCO2.toFixed(2))
      : undefined;
  }

  set totalCO2(value: number | undefined) {
    this._totalCO2 = value;
  }

  // Private field to store raw totalCO2 value
  private _totalCO2?: number;
}

export class MetaData {
  @serializable(alias('total_items', primitive()))
  totalItems?: number;

  @serializable(alias('total_pages', primitive()))
  totalPages?: number;

  @serializable(alias('current_page', primitive()))
  currentPage?: number;

  @serializable(alias('page_size', primitive()))
  pageSize?: number;
}

export class EmissionByLocationResponse {
  @serializable(
    alias('location_organization_emissions', list(object(LocationC02)))
  )
  locationCo2?: LocationC02[];

  @serializable(alias('metadata', object(MetaData)))
  meta?: MetaData;
}
